<template>
    <q-input
        v-model="innerValue"
        type="number"
        input-class="text-right"
        :class="{ required: required && !modelValue }"
        v-bind="defaultInputProps"
        step="0.01"
    >
        <template #prepend>
            <q-badge color="input" text-color="input">
                {{ currencyLabel }}
            </q-badge>
        </template>
    </q-input>
</template>

<script setup>
import { useAppStore } from 'src/stores/appStore.js'
import { computed } from 'vue'

const props = defineProps({
    modelValue: null,
    required: Boolean,
    readonly: Boolean,
    modelModifiers: {
        type: Object,
        default: () => ({}),
    },
    currencyId: Number,
})

const emit = defineEmits(['update:model-value'])
const appStore = useAppStore()

const rules = props.required
    ? [val => !!val || '* Required']
    : []

const innerValue = computed({
    get: () => props.modelValue,
    set: val => {
        let parsed = parseFloat(val)
        emit('update:model-value', parsed || parsed === 0 ? parsed : null)
    },
})

const defaultInputProps = computed(() => ({
    filled: !props.readonly,
    borderless: props.readonly,
    readonly: props.readonly,
    rules,
    dense: true,
    hideBottomSpace: true,
    step: 'any',
}))

let currencyLabel = props.currencyId
    ? appStore.lookupsById.currency[props.currencyId].symbol ?? '$'
    : '$'

</script>
